//import logo from './logo.svg';
import './App.css';
import AppLayout from './AppLayout';
import PlaceList from './components/PlaceList';

function App() {
  return (
    <div>
      <AppLayout />
    </div>
  );
}

export default App;
